import * as React from 'react';
import type { SVGProps } from 'react';
const SvgQuarantineAction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#C7A000"
      d="M7.962.091a1.01 1.01 0 0 0-.842 0l-5.917 2.51A1.95 1.95 0 0 0 0 4.4c.016 3.117 1.298 8.82 6.712 11.413a1.92 1.92 0 0 0 1.659 0c5.417-2.593 6.699-8.296 6.711-11.413a1.95 1.95 0 0 0-1.203-1.797zm-.42 3.931c.417 0 .753.336.753.754 0 .72.87 1.081 1.38.572a.754.754 0 0 1 1.065 1.065c-.509.51-.148 1.38.572 1.38.418 0 .754.336.754.754a.75.75 0 0 1-.754.754c-.72 0-1.081.87-.572 1.38a.754.754 0 0 1-1.065 1.065c-.51-.51-1.38-.148-1.38.571a.75.75 0 0 1-.754.755.75.75 0 0 1-.754-.755c0-.72-.87-1.08-1.38-.572a.754.754 0 0 1-1.065-1.065c.51-.509.148-1.38-.571-1.38a.75.75 0 0 1-.754-.753c0-.418.336-.754.754-.754.72 0 1.08-.87.572-1.38a.754.754 0 0 1 1.065-1.065c.509.509 1.38.148 1.38-.572 0-.418.335-.754.753-.754M6.535 8.295a.75.75 0 0 0 .754-.754.75.75 0 0 0-.754-.754.75.75 0 0 0-.754.754c0 .418.336.754.754.754M9.3 9.552a.75.75 0 0 0-.754-.754.75.75 0 0 0-.754.754c0 .418.336.754.754.754a.75.75 0 0 0 .754-.754"
    />
  </svg>
);
export default SvgQuarantineAction;
